import type { BillingAddressFormData } from "./types";

export interface NormalizedAddress {
  line1: string;
  line2?: string;
  city: string;
  state?: string;
  postalCode: string;
  country: string;
  phone?: string;
}

interface StripeBillingDetails {
  name: string;
  phone?: string;
  address?: {
    line1?: string;
    line2?: string;
    city?: string;
    state?: string;
    postal_code?: string;
    country?: string;
  };
}

/** Default-billing-address shape (from /billing/onboard) → normalized. */
export function fromDefaultBillingAddress(addr: BillingAddressFormData): NormalizedAddress {
  return {
    line1: addr.addressLine1,
    line2: addr.addressLine2 || undefined,
    city: addr.city,
    state: addr.state || undefined,
    postalCode: addr.zipCode,
    country: addr.country,
    phone: addr.phoneNumber || undefined,
  };
}

/** Custom add-card form shape → normalized. */
export function fromCustomAddCardAddress(addr: {
  countryCode: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  region: string;
  postalCode: string;
}): NormalizedAddress {
  return {
    line1: addr.addressLine1,
    line2: addr.addressLine2 || undefined,
    city: addr.city,
    state: addr.region || undefined,
    postalCode: addr.postalCode,
    country: addr.countryCode,
  };
}

export function toStripeBillingDetails(
  name: string,
  address: NormalizedAddress | null | undefined
): StripeBillingDetails {
  const details: StripeBillingDetails = { name };

  if (address) {
    details.address = {
      line1: address.line1,
      ...(address.line2 ? { line2: address.line2 } : {}),
      city: address.city,
      ...(address.state ? { state: address.state } : {}),
      postal_code: address.postalCode,
      country: address.country,
    };
    if (address.phone) {
      details.phone = address.phone;
    }
  }

  return details;
}
